import React, { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { errMessage } from "@/components/LoadError";

// v21 K3: wanneer een call te laat is; geldt vanaf de volgende call (de server rekent het moment uit).
const DAG = ["op de calldag zelf", "de dag na de call", "2 dagen na de call", "3 dagen na de call", "4 dagen na de call", "5 dagen na de call", "6 dagen na de call"];
const NL_DAG = ["zo", "ma", "di", "wo", "do", "vr", "za"];
const MND = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

const voorbeeld = (callDatum, dagen, tijd) => {
  if (!callDatum) return "";
  const [y, m, d] = callDatum.split("-").map(Number);
  const dt = new Date(y, m - 1, d + Number(dagen));
  return `${NL_DAG[dt.getDay()]} ${dt.getDate()} ${MND[dt.getMonth()]} ${/^\d{2}:\d{2}$/.test(tijd) ? tijd : "--:--"}`;
};

export function CallGrensEditor({ meta, onSaved, input, btnPrimary }) {
  const g = meta.callGrens;
  const [dagen, setDagen] = useState(g?.dagenNaCall ?? 1);
  const [tijd, setTijd] = useState(g?.tijd || "18:00");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (g) { setDagen(g.dagenNaCall); setTijd(g.tijd); } }, [g?.dagenNaCall, g?.tijd]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!g) return null;
  const vc = g.volgendeCall;
  const save = async () => {
    setSaving(true);
    try {
      await api.put("/config/call-grens", { dagenNaCall: Number(dagen), tijd, baseVersion: meta.configVersions?.callGrens });
      toast.success("Te-laat-grens opgeslagen");
      onSaved();
    } catch (e) {
      if (e?.response?.status === 409) { toast.error(e.response.data.detail); onSaved(); } else toast.error(errMessage(e));
    } finally { setSaving(false); }
  };
  return (
    <div data-testid="call-grens-editor" className="mb-3 md:mb-4 border-t border-zinc-100 pt-3">
      <label className="block text-xs uppercase tracking-wider font-semibold text-zinc-500 mb-1">Calls zijn te laat na</label>
      <div className="flex flex-wrap gap-2 mb-1">
        <select data-testid="call-grens-dagen" className={`${input} max-w-[220px]`} value={dagen} onChange={(e) => setDagen(Number(e.target.value))}>
          {DAG.map((t, i) => <option key={t} value={i}>{t}</option>)}
        </select>
        <input data-testid="call-grens-tijd" type="text" inputMode="numeric" placeholder="18:00" maxLength={5} className={`${input} max-w-[110px]`} value={tijd} onChange={(e) => setTijd(e.target.value)} />
      </div>
      <p data-testid="call-grens-voorbeeld" className="text-xs text-zinc-500 mb-1">
        Volgende call {vc?.callLabel} → te laat na {voorbeeld(vc?.callDatum, dagen, tijd)}. Een wijziging geldt vanaf de volgende call.
      </p>
      {g.klaarRegelsVanafLabel && <p data-testid="call-grens-klaar-vanaf" className="text-xs text-zinc-500 mb-2">WOW verplicht en checks tellen mee vanaf de call van {g.klaarRegelsVanafLabel}.</p>}
      <button className={btnPrimary} data-testid="save-call-grens" onClick={save} disabled={saving}><Save className="h-4 w-4" />Te-laat-grens opslaan</button>
    </div>
  );
}
